<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" class="padding_50">
                <el-form-item
                        class="margin_20"
                        prop="username"
                >
                    <el-input
                            v-model="form.username"
                            size="medium"
                            ref="username"
                            placeholder="用户名/手机号"
                            @keyup.enter.native="submit"
                    />
                </el-form-item>
                <el-form-item
                        class="margin_20"
                        prop="password"
                >
                    <el-input
                            v-model="form.password"
                            ref="password"
                            size="medium"
                            type="password"
                            placeholder="密码 6-16位"
                            @keyup.enter.native="submit"
                    />
                </el-form-item>
                <el-form-item
                        class="margin_20"
                >
                    <div style="float:left;">
                        <el-checkbox v-model="form.isAutoLogin">
                            自动登录
                        </el-checkbox>
                    </div>
                    <div style="float:right;">
                        <el-link
                                type="primary"
                                size="mini"
                                :underline="false"
                                @click="goTo('forgetPassword')"
                        >
                            忘记密码？
                        </el-link>
                    </div>
                </el-form-item>
                <el-col
                        :span="24"
                        class="margin_20"
                >
                    <el-button
                            type="primary"
                            :loading="is_post"
                            style="width:100%;"
                            @click="submit()"
                    >
                        登录
                    </el-button>
                </el-col>

<!--                <el-col-->
<!--                        :span="24"-->
<!--                        class="margin_20 gray_text"-->
<!--                >-->
<!--                    其他登录方式：-->
<!--                    <svg-icon-->
<!--                            class="other_login_icon"-->
<!--                            style="font-size:27px;"-->
<!--                            icon-class="wechat"-->
<!--                    />-->
<!--                    <svg-icon-->
<!--                            class="other_login_icon"-->
<!--                            icon-class="qq"-->
<!--                    />-->
<!--                </el-col>-->
        </el-form>
    </div>
</template>

<script>
    import request from "@/utils/request"

    export default {
        name: "AuthLogin",
        watch: {
            $route: {
                handler: function (route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        data() {
            return {
                form: {
                    username: "",
                    password: "",
                    isAutoLogin: true
                },
                rules:{
                    username:[
                        { required: true, message: '请填写您的用户名', trigger: 'blur' }
                    ],
                    password:[
                        { required: true, message: '请填写您的密码', trigger: 'blur' },
                        { min: 6, max: 16, message: '密码长度为6-16位', trigger: 'blur' }
                    ]
                },
                redirect:null,
                is_post: false
            }
        },
        methods: {
            goTo(name) {
                this.$router.push({name});
            },
            submit(){
                this.$refs["form"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                    this.$store.dispatch('user/login',this.form).then((res)=>{
                        //this.$router.push({path:this.redirect || '/dashboard'});
                        this.$router.push({path:'/dashboard'});
                        setTimeout(()=>{
                            this.is_post = false;
                        },1000);
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            }
        },
        mounted() {
            if (this.form.username === '') {
                this.$refs.username.focus()
            } else if (this.form.password === '') {
                this.$refs.password.focus()
            }
        },
        created() {

        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/element-variables.scss";

    .padding_50 {
        padding: 20px 50px 20px 10px;
        @media (max-width: 767px) {
            padding: 0 0 0 0;
        }
    }

    .margin_20 {
        width: 100%;
        margin: 20px 20px 0 20px;
        padding: 0 30px;
        @media (max-width: 767px) {
            margin: 0;
            padding: 10px 0;
        }
    }

    .gray_text {
        color: #999;
    }

    .other_login_icon {
        margin-left: 16px;
        color: rgba(0, 0, 0, .2);
        font-size: 24px;
        vertical-align: middle;
        cursor: pointer;
        transition: color .3s;
        line-height: 0;
        text-align: center;
        &:hover {
            color: $--color-primary;
        }
    }
</style>
